import { EventEmitter, Injectable } from '@angular/core';



@Injectable()
export class AppService {
	// use this service when you need to re-render app component
	// example if menu displays something from settigns or any other service you need to fire this event from that component
	// for more take a look at the source code of station-setup/new-station
	// pass arguments or commands
	onLoadApp: EventEmitter<string[]> = new EventEmitter<string[]>();

}
